import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import DeleteMembershipInvitation
    from 'src/features/membershipCloudUsers/components/forms/DeleteMembershipInvitation';
import { Invitation } from 'src/features/users/utils/types';
import { userMessages } from 'src/features/users/utils/messages';

interface CellMembershipCloudUserActionsProps<TData, TValue> extends CellContext<TData, TValue> {
    membershipId: string;
}

export default function CellMembershipInvitationActions({
    row,
    membershipId,
}: CellMembershipCloudUserActionsProps<Invitation, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex gap-1">
            <TooltipProvider>
                    <Tooltip>
                        <DeleteMembershipInvitation
                            selectedInvitation={row.original}
                            membershipId={membershipId}
                            semantics={{
                                entryName: formatMessage(userMessages.invitation).toLowerCase(),
                            }}
                        >
                            <TooltipTrigger asChild>
                                <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                    <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                </Button>
                            </TooltipTrigger>
                        </DeleteMembershipInvitation>
                        <TooltipContent>
                            <FormattedMessage {...generalMessages.delete} />
                        </TooltipContent>
                    </Tooltip>
            </TooltipProvider>
        </div>
    );
}
